
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_brdst_gol0z_9",
  "loading": "awsui_loading_brdst_gol0z_13",
  "undo-button": "awsui_undo-button_brdst_gol0z_17"
};
  